import { InjectionToken } from '@angular/core';

export class LogsModuleSettings {
  integrationGisLayerStepId: any;
}

export const LOGS_MODULE_SETTINGS = new InjectionToken<LogsModuleSettings>('LOGS_MODULE_SETTINGS');
